
window._ = require('lodash');

try {

	window.Popper        = require('popper.js/dist/umd/popper.js').default;    
  window.Selectric     = require('jquery-selectric');
  
  require('bootstrap');
  jQuery.fn.exists = function(){return this.length>0;}

} catch (e) {
  console.log(e);
}